export class Validators{

    static required  (msg = "Please enter value") {
        return (value) => {
            if ((Array.isArray(value) && value.length === 0) || !value) {
                return msg;
            }
            return '';
        };
    }
    static phoneNumberValid(msg = "Please enter valid Phone number"){
        return (value) => {
            const regex = /^[0-9]{10}$/;
            if (regex.test(value)) return '';  
            return msg; 
        }
    }
    static maxLength = (max, msg = `Maximum ${max} charcter`) => {
        return value => {

        if(value.length <= max) return '';

        return msg

        }
    }
    static minLength = (min, msg = `Minimum ${min} charcters required`) => {
        return value => {

        if(value && value.length >= min) return '';

        return msg

        }
    }
    static email = ( msg = "Please enter a valid email address")=> {
        return (value) => {
            let regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        
            if(regex.test(value)) return ''
            return msg

        }
    }
    static testMsg(msg = "message"){
        return (value) => {
            if(value){
                return msg
            }
            return ''
        }
    }

    static validateFormControl = (control, value) => {
        let error = ''
        let valid = true;
        var isHTML = RegExp.prototype.test.bind(/(<([^>]+)>)/i);
        /* checks all the validators for the control */
        const validators = control?.validators ? control?.validators : [];
        for (let validator of validators) {
            if (typeof validator == "function") {
                error = validator(isHTML(value) ? value.replace(/(<([^>]+)>)/ig, '') : value);
                // error = validator(value);
                if (error) {
                    valid = false;
                    break;
                }
            }
        }

        return { value, valid, error, validators };
    };

    static validateAndSetAllFormControls = (formControls, data) => {
        let controlKeys = Object.keys(formControls);
        controlKeys.forEach(controlKey => {
            let control = formControls[controlKey];
            formControls[controlKey] = this.validateFormControl(control, data[controlKey]);
        });

        return formControls;
    };

    static validateForm = (allControls) => {
        let formValid = true;
        let controls = Object.keys(allControls);
        for (let control of controls) {
            if (Array.isArray(allControls[control])) 
                continue;
            if (typeof allControls[control] === "object") {
                if (!allControls[control]?.valid) {
                    formValid = false;
                    break;
                }
            }
        }

        return formValid;
    };
    static validateAssessment = (assessmentData, sections) => {
        let formValid = true;
        let scrollid = "";
        let controls = Object.keys(assessmentData);
        for (let control of controls) {
            // TODO temp fix needs cleanup.
            if ( control === 'settings' ) {
                continue;
            } else if (typeof assessmentData[control] === "object") {
                assessmentData[control] = this.validateFormControl(assessmentData[control], assessmentData[control]?.value)
                if (!assessmentData[control]?.valid) {
                    formValid = false;
                    scrollid = "assessmentData"
                }
            }
        }
        sections = sections.map((section, sindex) => {
            section["sectionname"] = this.validateFormControl(section["sectionname"], section["sectionname"]?.value)
            if (!(section["sectionname"]?.valid)) {
                formValid = false;
                scrollid = scrollid !== "" ? scrollid : `section ${sindex}`
            }
            section["questions"] = section["questions"].map((question, qindex) => {
                question["questionname"] = this.validateFormControl(question["questionname"], question["questionname"]?.value)
                question["questiontype"] = this.validateFormControl(question["questiontype"], question["questiontype"]?.value)
                if (!(question["questionname"]?.valid && question["questiontype"]?.valid)) {
                    formValid = false;
                    scrollid = scrollid !== "" ? scrollid : `question ${sindex} ${qindex}`
                }
                
                if (question["optionset"].length > 0) {
                    question["optionset"] = question["optionset"].map((optionset) => {
                        optionset["options"] = optionset["options"].map((option) => {
                            option["optionname"] = this.validateFormControl(option["optionname"], option["optionname"]?.value)
                            if ((!option["optionname"]?.valid)) {
                                formValid = false;
                                scrollid = scrollid !== "" ? scrollid : `question ${sindex} ${qindex}`
                            }
                            return (option)
                        })
                        return (optionset)
                    })
                }
                return (question)
            })
            return section
        })
        return ({ formValid, assessmentData, sections, scrollid });
    };
    static onlyValidateAssessment = (assessmentData, sections) => {
        let formValid = true;
        let controls = Object.keys(assessmentData);
        let value = ""
        for (let control of controls) {
            if (typeof assessmentData[control] === "object") {
                value = this.validateFormControl(assessmentData[control], assessmentData[control]?.value)
                if (!value?.valid) {
                    formValid = false;
                }
            }
        }
        sections = sections.map((section) => {
            value = this.validateFormControl(section["sectionname"], section["sectionname"]?.value)
            if (!(value?.valid)) {
                formValid = false;
            }
            section["questions"] = section["questions"].map((question) => {
                value = this.validateFormControl(question["questionname"], question["questionname"]?.value)
                if (!(value?.valid)) {
                    formValid = false;
                }
                value = this.validateFormControl(question["questiontype"], question["questiontype"]?.value)
                if (!(value?.valid)) {
                    formValid = false;
                }
                if (question["optionset"].length > 0) {
                    question["optionset"] = question["optionset"].map((optionset) => {
                        optionset["options"] = optionset["options"].map((option) => {
                            value = this.validateFormControl(option["optionname"], option["optionname"]?.value)
                            if ((!value?.valid)) {
                                formValid = false;
                            }
                            return (option)
                        })
                        return (optionset)
                    })
                }
                return (question)
            })
            return section
        })
        return (formValid);
    };

    static validateAssessmentSummary = (summary) => {
        let formValid = true;
        summary?.forEach((summaryItem, sindex) => {
            summaryItem["summaryname"] =JSON.parse(JSON.stringify( this.validateFormControl(summaryItem["summaryname"], summaryItem["summaryname"]?.value)))
            summaryItem["basedon"] = this.validateFormControl(summaryItem["basedon"], summaryItem["basedon"]?.value)
            if (!(summaryItem["summaryname"]?.valid && summaryItem["basedon"]?.valid)) {
                formValid = false;
            }
            summaryItem['defaultconfiguration']?.forEach((config) => {
                config["operator"] = this.validateFormControl(config["operator"], config["operator"]?.value)
                config["scoremin"] = this.validateFormControl(config["scoremin"], config["scoremin"]?.value)
                config["description"] = this.validateFormControl(config["description"], config["description"]?.value)
                config["indicatorname"] = this.validateFormControl(config["indicatorname"], config["indicatorname"]?.value)
                if (!(config["operator"]?.valid && config["scoremin"]?.valid && config["description"]?.valid && config["indicatorname"]?.valid)) {
                    formValid = false;
                }
                if (config["operator"]?.valid && config["operator"]?.value === '<>') {
                    config["scoremax"] = this.validateFormControl(config["scoremax"], config["scoremax"]?.value)
                    if (!(config["scoremax"]?.valid)) {
                        formValid = false;
                    }
                }

            })
            summaryItem['kpi']?.forEach((kpi) => {
                kpi["indicatorname"] = this.validateFormControl(kpi["indicatorname"], kpi["indicatorname"]?.value)
                if (!(kpi["indicatorname"]?.valid)) {
                    formValid = false;
                }
                kpi['configuration']?.forEach((kpiconfig) => {
                    kpiconfig["operator"] = this.validateFormControl(kpiconfig["operator"], kpiconfig["operator"]?.value)
                    kpiconfig["score"] = this.validateFormControl(kpiconfig["score"], kpiconfig["score"]?.value)
                    kpiconfig["displayname"] = this.validateFormControl(kpiconfig["displayname"], kpiconfig["displayname"]?.value)
                    kpiconfig["color"] = this.validateFormControl(kpiconfig["color"], kpiconfig["color"]?.value)
                    if (!(kpiconfig["operator"]?.valid && kpiconfig["score"]?.valid && kpiconfig["displayname"]?.valid && kpiconfig["color"]?.valid)) {
                        formValid = false;
                    }
                })
            })
        })
        return ({ formValid, summary })
    }
   
}